const MOBILE_MAX_SIZE = 640
const DESIGN_WIDTH = 375
const REM2PX = 100

function recalculate() {
    const clientWidth = Math.min(document.documentElement.clientWidth, MOBILE_MAX_SIZE)
    const fontSize = clientWidth / DESIGN_WIDTH * REM2PX
    document.documentElement.style.fontSize = fontSize + 'px'
}

window.addEventListener('load', recalculate, false)
window.addEventListener('resize', recalculate, false)
window.addEventListener('orientationchange', recalculate, false)
document.addEventListener('DOMContentLoaded', recalculate, false)
recalculate()
